import React from 'react';

const PollingStatusBanner = ({ status, hasError }) => {
  if (hasError) {
    return (
      <div className="mb-4 rounded-lg bg-yellow-50 border border-yellow-200 px-4 py-3 flex items-center gap-2 text-sm text-yellow-800">
        <span>⚠</span>
        <span>Unable to fetch latest status. Retrying...</span>
      </div>
    );
  }

  if (status === 'RUNNING') {
    return (
      <div className="mb-4 rounded-lg bg-blue-50 border border-blue-200 px-4 py-3 flex items-center gap-3 text-sm text-blue-800 animate-pulse">
        <span className="relative flex h-3 w-3 shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-500 opacity-75" />
          <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500" />
        </span>
        <span className="font-medium">Generating invoices...</span>
        <span className="text-blue-600 text-xs">Refreshing every 10 seconds</span>
      </div>
    );
  }

  if (status === 'COMPLETED') {
    return (
      <div className="mb-4 rounded-lg bg-green-50 border border-green-200 px-4 py-3 flex items-center gap-2 text-sm text-green-800">
        <span>✓</span>
        <span className="font-medium">Generation completed successfully.</span>
      </div>
    );
  }

  if (status === 'COMPLETED_WITH_ERRORS') {
    return (
      <div className="mb-4 rounded-lg bg-yellow-50 border border-yellow-200 px-4 py-3 flex items-center gap-2 text-sm text-yellow-800">
        <span>⚠</span>
        <span className="font-medium">Generation completed with some errors. Check failed enterprises below.</span>
      </div>
    );
  }

  if (status === 'FAILED') {
    return (
      <div className="mb-4 rounded-lg bg-red-50 border border-red-200 px-4 py-3 flex items-center gap-2 text-sm text-red-800">
        <span>✕</span>
        <span className="font-medium">Generation failed. Please try again.</span>
      </div>
    );
  }

  return null;
};

export default PollingStatusBanner;
